import { useEffect, useState } from "react";
import type { AuditEntry } from "../../../../packages/admin-ui/src/index";
import { api } from "../api";

export function AuditScreen() {
  const [entries, setEntries] = useState<AuditEntry[]>([]);
  const [error, setError] = useState<string | null>(null);

  async function load() {
    setError(null);
    try {
      setEntries(await api.listAudit(100));
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  }

  useEffect(() => {
    void load();
  }, []);

  return (
    <div className="panel">
      <h2>Audit log <button className="ghost" onClick={load}>Yenile</button></h2>
      {error && <p className="error">{error}</p>}
      <table>
        <thead>
          <tr>
            <th>Zaman</th>
            <th>Aktör</th>
            <th>Aksiyon</th>
            <th>Varlık</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((e) => (
            <tr key={e.id}>
              <td className="muted">{new Date(e.createdAt).toLocaleString()}</td>
              <td>{e.actor}</td>
              <td><span className="badge">{e.action}</span></td>
              <td className="muted">{e.entityType}:{e.entityId.slice(0, 8)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {entries.length === 0 && !error && <p className="muted">Kayıt yok.</p>}
    </div>
  );
}
